import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { List } from 'immutable';
import { ProductService } from '../../services/product.service';
import { Product } from '../../models';

interface IRow {
  ID: number;
  name: string;
  brand: string;
  size: string;
  expectedCount: number;
  supplierID: number;
}

interface primeNgCol {
  field: string;
  header: string;
}

export interface IProductListModalCallBackData {
  selectedProducts: List<Product>;
}
@Component({
  selector: 'smr-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {

  public isLoading: boolean;

  public submitted: boolean;

  public stats: Array<IRow>;

  public rawData: Array<IRow>;

  public selectedProducts: Product[];

  public cols: primeNgCol[];

  public errorOccurredWhileLoadingProducts: boolean = false;

  public errorOccurredWhileLoadingProductInfo: boolean;

  public product: Product;

  public products: List<Product>;
  @Input() supplierID: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private productService: ProductService
  ) {
    this.isLoading = true;
    this.submitted = false;
    this.stats = [];

    this.cols = [
      { field: 'ID', header: 'ID' },
      { field: 'name', header: 'Name' },
      { field: 'brand', header: 'Brand' },
      { field: 'size', header: 'Size' },
      { field: 'expectedCount', header: 'Expected count' }
    ];
  }

  public onDismiss() {
    this.modalCtrl.dismiss();
  }

  public ngOnInit() {
    this.refresh();
  }

  public refresh() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProductInfo = false;
    this.loadProducts();
  }

  public loadProducts() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProducts = false;

    this.productService.loadProducts().subscribe({
      next: (products) => {
        this.isLoading = false;
        this.products = products.filter((product) => {
          return product.trackInventory === 1;
        });
        this.mapPaginatorValue();
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingProducts = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  public mapPaginatorValue() {
    this.products
      .filter((p) => {
        if (this.supplierID) {
          return p.supplierID === this.supplierID;
        } else {
          return true;
        }
      })
      .forEach((product) => {
        let ID = product.getID();
        let name = product.getName();
        let brand = product.brand?.getName() ? product.brand?.getName() : "";
        let size = product.size;
        let expectedCount = product.getStock();
        let supplierID = product.getSupplierID();
        this.stats.push({ ID, name, brand, size, expectedCount, supplierID });
      });

      this.rawData = this.stats;
  }

  public sendProductList(selectedProducts) {
    this.submitted = true;

    let callbackData: IProductListModalCallBackData = {
      selectedProducts: selectedProducts
    };
    this.isLoading = false;
    this.modalCtrl.dismiss(callbackData);
  }


  search(event) {
    const keyword = event.target.value.toLowerCase();
    this.stats = this.rawData.filter((stat) => {
      return stat.name.toLowerCase().includes(keyword)
      || stat.ID == parseInt(keyword)
    })
  }

}
